export default __webpack_public_path__ + "static/media/photo--lg--126.54efa632.jpg";